module.exports = __webpack_public_path__ + "img/elasticbitcoin-RANDOMIZED-REBASING.dfea4cb5.svg";